import React from 'react'
import EshopCategory from './EshopCategory'

const EshopPetit = ({ products = [], eshopInfo = null }) => (
    <EshopCategory products={products} category="petit" eshopInfo={eshopInfo} />
)

export default EshopPetit